/* esm.sh - rxjs@7.8.1/dist/esm/internal/observable/interval */
import{asyncScheduler as m}from"../scheduler/async.mjs";import{timer as n}from"./timer.mjs";function e(r=0,t=m){return r<0&&(r=0),n(r,r,t)}export{e as interval};
//# sourceMappingURL=interval.mjs.map